
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/giftCard/defCreate",
      function () {
        return require("private-next-pages/giftCard/defCreate.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/giftCard/defCreate"])
      });
    }
  